var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrenada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 39.9999C31.0461 39.9999 40.0004 31.0456 40.0004 19.9999C40.0004 8.95419 31.0461 -0.000114441 20.0004 -0.000114441C8.95467 -0.000114441 0.000366211 8.95419 0.000366211 19.9999C0.000366211 31.0456 8.95467 39.9999 20.0004 39.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72766 3.47824C11.9374 1.28402 15.8185 -3.8147e-05 20.0001 -3.8147e-05C24.1816 -3.8147e-05 28.0627 1.28402 31.2725 3.47824L20.0001 4.34777L8.72766 3.47824Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 20L18.7237 18.7236L18.3848 19.3307L20.0001 20Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85785 5.85782C-1.95262 13.6683 -1.95262 26.3316 5.85785 34.1422C9.08543 30.9146 12.1896 27.8105 20 20L5.85785 5.85782Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1423 5.85782C41.9528 13.6683 41.9528 26.3316 34.1423 34.1422C30.9147 30.9146 27.8106 27.8105 20.0001 20L34.1423 5.85782Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 26.9564C23.842 26.9564 26.9565 23.8419 26.9565 19.9999C26.9565 16.158 23.842 13.0434 20.0001 13.0434C16.1581 13.0434 13.0436 16.158 13.0436 19.9999C13.0436 23.8419 16.1581 26.9564 20.0001 26.9564Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13.0434L21.5593 17.8425H26.606L22.5234 20.8092L24.0827 25.6085L20 22.6425L15.9172 25.6085L17.4768 20.8092L13.3942 17.8425H18.4406L20 13.0434Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 -8.39233e-05C19.9979 -8.39233e-05 19.9957 7.23267e-05 19.9934 7.23267e-05H20.0068C20.0046 7.23267e-05 20.0024 -8.39233e-05 20.0001 -8.39233e-05V-8.39233e-05Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0067 -8.39233e-05H19.9933C14.4736 0.00171295 9.47662 2.23945 5.85889 5.85679H34.1412C30.5233 2.23945 25.5264 0.00171295 20.0067 -8.39233e-05Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85889 34.1431C9.4781 37.7618 14.4776 39.9999 19.9999 39.9999C25.5222 39.9999 30.5217 37.7618 34.1409 34.1431H5.85889Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 2.17395L20.3239 3.17036H21.3715L20.5239 3.78622L20.8478 4.78262L20 4.16684L19.1524 4.78262L19.4763 3.78622L18.6285 3.17036H19.6762L20 2.17395Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1503 2.17395L15.4741 3.17036H16.5218L15.6742 3.78622L15.998 4.78262L15.1503 4.16684L14.3028 4.78262L14.6265 3.78622L13.7788 3.17036H14.8265L15.1503 2.17395Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8498 2.17395L25.1736 3.17036H26.2212L25.3737 3.78622L25.6975 4.78262L24.8498 4.16684L24.0022 4.78262L24.326 3.78622L23.4783 3.17036H24.5259L24.8498 2.17395Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 35.2175L20.3239 36.2139H21.3715L20.5239 36.8297L20.8478 37.8261L20 37.2103L19.1524 37.8261L19.4763 36.8297L18.6285 36.2139H19.6762L20 35.2175Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1503 35.2175L15.4741 36.2139H16.5218L15.6742 36.8297L15.998 37.8261L15.1503 37.2103L14.3028 37.8261L14.6265 36.8297L13.7788 36.2139H14.8265L15.1503 35.2175Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8498 35.2175L25.1736 36.2139H26.2212L25.3737 36.8297L25.6975 37.8261L24.8498 37.2103L24.0022 37.8261L24.326 36.8297L23.4783 36.2139H24.5259L24.8498 35.2175Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09398 19.6696C6.60766 20.4813 6.36625 21.5556 5.55461 22.0693C4.74305 22.5831 3.66867 22.3417 3.15492 21.53C2.22484 20.0607 2.76414 17.6609 2.76414 17.6609C2.76414 17.6609 5.16383 18.2002 6.09398 19.6696V19.6696Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08962 22.2042C5.56985 22.2042 5.95915 21.8149 5.95915 21.3347C5.95915 20.8545 5.56985 20.4652 5.08962 20.4652C4.6094 20.4652 4.22009 20.8545 4.22009 21.3347C4.22009 21.8149 4.6094 22.2042 5.08962 22.2042Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrenada);
export default __webpack_public_path__ + "static/media/grenada.fb3462643664089b2b96f1c483e0ad01.svg";
export { ForwardRef as ReactComponent };